import React from "react";

const Logo = () => {
  return (
    <div className="logo-container">
      <div className="logo-text">Webnet</div>
    </div>
  );
};

export default Logo;
